export default "__VITE_ASSET__8SIFDqaH__"